import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { IRootState } from './types';
/**
 * Type-safe implementation of the `useSelector()` hook that uses
 * the `IRootState` type.
 */
export const useTypedSelector: TypedUseSelectorHook<IRootState> = useSelector;
